import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import loggedIn from './LoggedIn';
import signIn from './SignIn';
import register from './Register';
import marketingPreferences from './MarketingPreferences';

const rootReducer = combineReducers({
  router: routerReducer,
  loggedIn,
  signIn,
  register,
  marketingPreferences,
});

export default rootReducer;
